import SearchIcon from '@mui/icons-material/Search';
import { Badge, Button, InputAdornment, Stack, TextField } from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarDensitySelector } from '@mui/x-data-grid';
import Iconify from 'src/components/iconify';

type EventsTableToolbarProps = {
  searchText: string;
  selectedFiltersCount: number;
  handleClickFilters: () => void;
  setSearchText: (value: string) => void;
};

export function EventsTableToolbar({
  searchText,
  selectedFiltersCount,
  handleClickFilters,
  setSearchText,
}: EventsTableToolbarProps) {
  return (
    <Stack direction="row" justifyContent="space-between" width="100%">
      <TextField
        placeholder="Pesquisar por nome..."
        variant="standard"
        size="small"
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: 'text.primary' }} />
            </InputAdornment>
          ),
        }}
        sx={{
          minWidth: 250,
          '& input': {
            color: 'text.primary',
            opacity: 0.8,
          },
        }}
      />

      <Stack direction="row" spacing={0.5}>
        <Button
          size="small"
          startIcon={
            <Badge
              color="primary"
              badgeContent={selectedFiltersCount}
              invisible={selectedFiltersCount === 0}
              overlap="circular"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <Iconify icon="mdi:filter-variant" />
            </Badge>
          }
          onClick={handleClickFilters}
        >
          Filtros
        </Button>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
      </Stack>
    </Stack>
  );
}
